import React, { useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Stack, Box, Button, Card, InputBase, Dialog, DialogTitle, DialogContent, TextField, MenuItem, DialogActions, Typography, TableContainer, TableHead, TableBody, Paper, Table, TableRow, TableCell, Popover, DialogContentText, CircularProgress, Grid } from '@mui/material';
import Iconify from 'src/components/iconify';
import { getData, postData, putData, uploadFile } from 'src/webService/webService';
import { toast } from 'react-toastify';
import PaginationComponent from 'src/components/pagination';
import wordIcon from '../../components/logo/icons-word.png'
import pdfIcon from '../../components/logo/icons-pdf.png'
import { file_URL } from '../../utils/url'

function ContentCreationSelfAssigned() {

    const [open, setOpen] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);
    const UserId = sessionStorage.getItem('userId');
    const [view, setView] = useState([]);
    const [details, setDetails] = useState(false);
    const [scroll, setScroll] = useState('paper');
    const descriptionElementRef = useRef(null);
    const [selectedLead, setSelectedLead] = useState("");
    const [allUpdates, setAllUpdates] = useState([]);
    const [fileUpload, setFileUpload] = useState(null);
    const [selectedWorkUpdateId, setSelectedWorkUpdateId] = useState(null);
    const [convertForm, setConvertForm] = useState(false);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState({});
    const [dailyData, setDailyData] = useState("");
    const [contentCreationData, setContentCreationData] = useState([]);

    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const [assignedLeads, setAssignedLeads] = useState([]);
    const [openImage, setOpenImage] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');

    const sessionToken = sessionStorage.getItem("Token");
    const role = sessionStorage.getItem("role");
    const roleType = sessionStorage.getItem("roleType");
    const serviceTeamType = sessionStorage.getItem("serviceTeamType");
    const userId = sessionStorage.getItem("userId");

    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [formData, setFormData] = useState({
        projectName: "",
        contentType: "",
        targetAudience: "",
        keywords: "",
        seoFocus: "",
        status: "",
        fileUpload: "",
        comments: "",
        completionStatus: "",
        totalTasks: "",
        completedTasks: ""
    });

    const getAllUsers = async () => {
        try {
            const params = { page: 1, limit: 1000 }
            const response = await getData("users/users", params);
            console.log("Response:", response);

            let filteredUsers = [];

            if (role === "Admin") {
                filteredUsers = response.data.results.filter(user =>
                    user.serviceTeamType && user.serviceTeamType.includes("Camera Man") && user.roleType === "Team Leader"
                );
            } else if (roleType === "Team Leader") {
                filteredUsers = response.data.results.filter(user =>
                    user.serviceTeamType && user.serviceTeamType.includes("Content Creation")
                );
            }

            const formattedOptions = filteredUsers.map(user => ({
                id: user._id,
                name: user.name
            }));

            setEmployeeOptions(formattedOptions);
        } catch (error) {
            console.error("Error fetching users:", error);
            toast.error(`Failed to load users ${error ? error : ''}`);
        }
    };

    const getAllLeads = async (skip = currentPage, limit = 5) => {
        const parmas = {
            page: skip,
            limit: limit
        }
        try {
            console.log("Fetching users...");
            console.log("Token being sent:", sessionToken);

            const response = await getData(`leads/leads/${userId}`, parmas, sessionToken);
            console.log("Response:", response)

            const responseData = response?.data[0]?.paginatedResults || [];

            setContentCreationData(responseData)
            setTotalPages(response.data[0].totalPages);
            setTotalCount(response.data[0].totalCount.totalItems);

        }
        catch (error) {
            console.error("Error fetching users:", error);
        }
    }

    const handleFormChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleFileChange = (event, leadId) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFiles(prev => ({ ...prev, [leadId]: file }));
            handleFileUpload(file, leadId);
        }
    };

    const handleFileUpload = async (fileupload, leadId) => {
        console.log("Fileupload:", fileupload);
        console.log("Is File:", fileupload instanceof File);

        const formDataToSend = new FormData();
        formDataToSend.append("file", fileupload);

        try {
            const response = await uploadFile(`files/upload/${selectedLeadId}`, formDataToSend);
            if (response?.status === 200) {
                toast.success("File uploaded successfully!");
                setFileUpload(response?.data);
                setFormData(prevState => ({
                    ...prevState,
                    fileupload: response?.data,
                }));
            } else {
                toast.error("File upload failed!", response?.message);
            }
        } catch (error) {
            console.error("File upload error:", error);
            toast.error(`Error uploading file ${error ? error : ''}`);
        }
    };

    const handleOpenMenu = (event, task, id, workUpdateId) => {
        let lead;
        if (task && typeof task === 'object') {
            lead = task;
            setSelectedLead(lead);
        }
        else {
            lead = assignedLeads.find((data) => data._id === id);
            setSelectedLead(lead);
        }

        if (event?.currentTarget) {
            setOpenMenu(event.currentTarget);
            setSelectedLeadId(id);
            setSelectedWorkUpdateId(workUpdateId);
            setView(lead || task);
        }
    };

    const handleCloseMenu = () => {
        setOpenMenu(false);
    };

    const handleOpenDialog = async () => {
        await getAllUpdatesAdmin();
        setDetails(true);
        handleCloseMenu();
    };

    const handleCloseDialog = () => {
        setDetails(false);
    };

    const handleOpen = async () => {
        setOpen(true);
        handleCloseMenu();
    }

    const handleClose = () => {
        setOpen(false)
    }

    useEffect(() => {
        if (details) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [details]);

    const getDailyUpdates = async () => {
        try {
            const response = await getData(`dailyworkupdates/user/${UserId}`, {}, sessionToken);
            console.log("Response Daily Updates:", response)
            const results = response?.data;
            console.log("Results:", results)
            setDailyData(results);

        } catch (err) {
            console.error("Error while fetching Conent Creation Team:", err);
            toast.error(`Failed to load Content Creation Team. ${err ? err : ''}`);
        }

    }

    const getAllUpdatesAdmin = async () => {

        const params = {
            page: 1,
            limit: 1000
        }

        try {
            const response = await getData("dailyworkupdates/updates", params, sessionToken);
            console.log("Response Dailyyy Updates:", response)

            const filteredData = response?.data[0]?.paginatedResults?.filter(lead => lead.serviceName === "Content Creation");

            console.log("Filtered Data:", filteredData);
            setAllUpdates(filteredData); // Store all data here
            // setView(filteredData);

        } catch (err) {
            console.error("Error while fetching Content Creation Team:", err);
            toast.error(`Failed to load Content Creation Team. ${err ? err : ''}`);
        }

    }

    const postDailyWorkUpdate = async () => {
        debugger
        try {
            // First check if updates exist for this lead
            const checkResponse = await getData(`dailyworkupdates/${selectedLeadId}`, {}, sessionToken);
            const existingUpdates = checkResponse?.data?.map(update => update?.contentCreationHistory?.map(history => history?.dailyUpdateId));

            const contentCreationHistory = selectedLead?.contentCreationHistory?.[0] ||
                selectedLead?.contentCreationHistory ||
                {};
            const previousCompleted = contentCreationHistory.completedTasks || 0;
            const newCompleted = parseInt(formData.completedTasks, 10) || 0;
            const totalCompleted = previousCompleted + newCompleted;

            const deadline = selectedLead?.contentCreationHistory?.[0]?.deadline ||
                selectedLead?.contentCreationHistory?.deadline ||
                '';
            const amount = selectedLead?.contentCreationHistory?.[0]?.amount ||
                selectedLead?.contentCreationHistory?.amount ||
                '';
            const assignedTo = selectedLead?.contentCreationHistory?.[0]?.assignedTo ||
                selectedLead?.contentCreationHistory?.assignTo ||
                '';
            const totalTasks = selectedLead?.contentCreationHistory?.[0]?.totalTasks ||
                selectedLead?.contentCreationHistory?.totalTasks ||
                '';
            const status = selectedLead?.contentCreationHistory?.[0]?.totalTasks === totalCompleted ? "Completed" : "In Progress";

            const payLoad = {
                deadline,
                assignedTo,
                amount,
                status,
                fileUpload: fileUpload,
                comments: formData.comments,
                totalTasks,
                completedTasks: totalCompleted,
                serviceName: "Content Creation",
                leadId: selectedLeadId,
                userId: UserId
            };

            let response;

            if (existingUpdates.length === 0) {
                // POST new update if none exists
                response = await postData('dailyworkupdates', payLoad, sessionToken);
            } else {
                // PUT update existing record
                const updateId = existingUpdates[existingUpdates.length - 1]; // Get first update's ID
                console.log(existingUpdates);
                response = await putData(`dailyworkupdates/dailyworkupdates/${updateId}`, payLoad, sessionToken);
            }

            if (response?.status === 200) {
                toast.success("Daily Work Updated Successfully!");
                handleClose();
                getDailyUpdates();
                getAllLeads();
            } else {
                throw new Error(response?.message || "Failed to update Daily Work.");
            }

        } catch (error) {
            console.error("Error:", error);
            toast.error(`${error ? error : ''}`);
        }
    };

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        if (currentPage === 1) {
            setLimit(event.target.value)
            getAllLeads(1, event.target.value)
        }
        else {
            setCurrentPage(1);
            setLimit(event.target.value);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
            getAllLeads(currentPage - 1, limit);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
            getAllLeads(currentPage + 1, limit);
        }
    };

    const calculateIndex = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };

    useEffect(() => {
        getAllUsers();
        getAllUpdatesAdmin();
        getAllLeads(currentPage, limit);
        getDailyUpdates();
    }, [role, roleType, serviceTeamType, currentPage, limit]);

    return (
        <>
            <Helmet>
                <title>Self Assigned Content Creation</title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Self Assigned Tasks
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                backgroundColor: "white",
                                borderRadius: "15px",
                                padding: "4px 12px",
                                boxShadow: 1,
                                marginRight: "20px"
                            }}
                        >
                            <Iconify icon="eva:search-fill" />
                            <InputBase
                                placeholder="Search"
                                sx={{ marginLeft: "8px" }}
                            />
                        </Box>
                    </Box>
                </Stack>
                <Card sx={{ padding: 2, boxShadow: 3, backgroundColor: "#fff" }}>


                    <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                        <Table>
                            <TableHead>
                                <TableCell>S.No</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Contact</TableCell>
                                <TableCell>Assigned Work</TableCell>
                                <TableCell>Deadline</TableCell>
                                <TableCell>Completed Tasks</TableCell>
                                <TableCell>File</TableCell>
                                <TableCell>Progress</TableCell>
                                <TableCell></TableCell>
                            </TableHead>
                            <TableBody>
                                {
                                    contentCreationData?.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={9} align="center">
                                                No data found
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        contentCreationData?.map((work, id) => {
                                            return (
                                                <TableRow key={work?.id}>
                                                    <TableCell>{calculateIndex(id)}</TableCell>
                                                    <TableCell>{work?.name}</TableCell>
                                                    <TableCell>{work?.phone}</TableCell>
                                                    <TableCell>{work?.currentWork?.noOfPosters}</TableCell>
                                                    <TableCell>{work?.currentWork !== null ? new Date(work?.currentWork?.deadline).toLocaleDateString() : "-"}</TableCell>
                                                    <TableCell>{work?.contentCreationHistory[0]?.completedTasks} / {work?.contentCreationHistory[0]?.totalTasks}</TableCell>
                                                    <TableCell>
                                                        {work?.contentCreationHistory[0]?.fileUpload?.path ?
                                                            <img
                                                                src={work?.contentCreationHistory[0]?.fileUpload?.path
                                                                    ? `${file_URL + encodeURI(work?.contentCreationHistory[0]?.fileUpload?.path.replace("public/", ""))}`
                                                                    : "#"}
                                                                alt='Image.png'
                                                                style={{ maxWidth: "50px", cursor: "pointer" }}
                                                                onClick={() => {
                                                                    const fullImage = work?.contentCreationHistory[0]?.fileUpload?.path
                                                                        ? `${file_URL + encodeURI(work?.contentCreationHistory[0]?.fileUpload?.path.replace("public/", ""))}`
                                                                        : "#";
                                                                    setSelectedImage(fullImage);
                                                                    setOpenImage(true);
                                                                }}
                                                            />
                                                            : "-"}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Box position="relative" display="inline-flex">
                                                            <CircularProgress
                                                                variant="determinate"
                                                                value={work?.contentCreationHistory[0]?.completionPercentage}
                                                            />
                                                            <Box
                                                                top={0}
                                                                left={0}
                                                                bottom={0}
                                                                right={0}
                                                                position="absolute"
                                                                display="flex"
                                                                alignItems="center"
                                                                justifyContent="center"
                                                            >
                                                                <Typography variant="caption" component="div" color="text.secondary">
                                                                    {typeof work?.contentCreationHistory[0]?.completionPercentage === 'number'
                                                                        ? `${Math.round(work.contentCreationHistory[0].completionPercentage)}%`
                                                                        : '0%'}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Iconify
                                                            icon="material-symbols-light:more-vert"
                                                            sx={{ margin: "auto" }}
                                                            onClick={(event) => handleOpenMenu(event, work, work._id, work?.contentCreationHistory[0]?.dailyUpdateId)}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })
                                    )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <PaginationComponent
                        name={"Leads"}
                        totalcount={totalCount}
                        limit={limit}
                        handleLimitChange={handleLimitChange}
                        handlePrevPage={handlePrevPage}
                        handleNextPage={handleNextPage}
                        currentPage={currentPage}
                        totalPages={totalPages}
                    />
                </Card>

                {/* Events Dialog */}
                <Dialog open={open} onClose={() => setOpen(false)}>
                    <DialogTitle>Daily Work Update</DialogTitle>
                    <DialogContent>
                        <TextField
                            name="completedTasks"
                            label="Completed Tasks"
                            type="number"
                            fullWidth
                            margin="dense"
                            value={formData.completedTasks}
                            onChange={handleFormChange}
                        />
                        <TextField
                            name="comments"
                            label="Comments"
                            fullWidth
                            margin="dense"
                            value={formData.comments}
                            onChange={handleFormChange}
                        />
                        {/* <TextField
                            name="status"
                            label="Status"
                            fullWidth
                            select
                            margin="dense"
                            value={formData.status}
                            onChange={handleFormChange}
                        >
                            <MenuItem value="Pending">Pending</MenuItem>
                            <MenuItem value="In Progress">In Progress</MenuItem>
                            <MenuItem value="Completed">Completed</MenuItem>
                        </TextField> */}
                        <TextField
                            margin='dense'
                            type='file'
                            hidden
                            label="Upload File"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => handleFileChange(e)}
                        >
                        </TextField>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpen(false)} color="secondary">Cancel</Button>
                        <Button color="primary" onClick={postDailyWorkUpdate}>Update</Button>
                    </DialogActions>
                </Dialog>

                <Popover
                    open={Boolean(openMenu)}
                    anchorEl={openMenu}
                    onClose={handleCloseMenu}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                        sx: {
                            p: 1,
                            width: 140,
                            '& .MuiMenuItem-root': {
                                px: 1,
                                typography: 'body2',
                                borderRadius: 0.75,
                            },
                        },
                    }}
                >
                    <>
                        <MenuItem onClick={handleOpenDialog}>
                            <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                            View
                        </MenuItem>
                        <MenuItem onClick={handleOpen}>
                            <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                            Work Update
                        </MenuItem>
                    </>
                </Popover>

                <Dialog
                    open={details}
                    onClose={handleCloseDialog}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title">
                        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
                            Daily Work Updates
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                            component="div" // Ensure DialogContentText renders as a div to contain Box/Grid
                        >
                            {!view || Object.keys(view).length === 0 ? (
                                <Box sx={{ p: 3, textAlign: 'center' }}>
                                    <Typography variant="h6" color="text.secondary">No data found</Typography>
                                </Box>
                            ) : (
                                <Box sx={{ p: 1 }}>
                                    <Paper elevation={3} sx={{
                                        p: 2,
                                        backgroundColor: '#ffffff',
                                        borderRadius: 2,
                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                        borderLeft: '5px solid #1976d2' // A subtle accent line
                                    }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Project Details
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Name: {view?.name}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Content Type: {view?.contentCreationHistory[0]?.contentType}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Deadline: {new Date(view?.contentCreationHistory[0]?.deadline).toLocaleDateString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Status: <Typography component="span" sx={{
                                                        fontWeight: 'bold',
                                                        color: view?.contentCreationHistory[0]?.status === 'Completed' ? 'success.main' :
                                                            view?.contentCreationHistory[0]?.status === 'In Progress' ? 'warning.main' : 'error.main'
                                                    }}>
                                                        {view?.contentCreationHistory[0]?.status}
                                                    </Typography>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    SEO Focus: {view?.contentCreationHistory[0]?.seoFocus}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Task Progress
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Completed Tasks: {view?.contentCreationHistory[0]?.completedTasks}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Total Tasks: {view?.contentCreationHistory[0]?.totalTasks}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="body1">
                                                    Progress: <Typography component="span" sx={{ fontWeight: 'bold', color: '#007bff' }}>
                                                        {view?.contentCreationHistory[0]?.completionPercentage}%
                                                    </Typography>
                                                </Typography>
                                            </Grid>

                                            {view?.[0]?.contentCreationHistory[0]?.comments && (
                                                <Grid item xs={12} id="paddingTop">
                                                    <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#333' }}>
                                                        Comments
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                                                        "{view?.[0]?.contentCreationHistory[0]?.comments}"
                                                    </Typography>
                                                </Grid>
                                            )}

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Timestamps
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Created: {new Date(view?.createdAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Updated: {new Date(view?.updatedAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                                            <Table sx={{ minWidth: 350 }} aria-label="customized table">
                                                <TableBody>
                                                    {view?.contentCreationHistory?.map((history, hIndex) => (
                                                        <TableRow
                                                            key={`${view?.name || "row"}-${hIndex}`}
                                                            hover
                                                            onClick={() => {
                                                                const fileUrl = `${file_URL + encodeURI(
                                                                    history.fileUpload.path.replace("public/", "")
                                                                )}`;
                                                                window.open(fileUrl, "_blank");
                                                            }}
                                                        >
                                                            <TableCell align="right">{hIndex + 1}</TableCell>
                                                            <TableCell align="right">
                                                                {history?.fileUpload?.path ? (
                                                                    (() => {
                                                                        const filePath = history.fileUpload.path.toLowerCase();
                                                                        const fileUrl = `${file_URL + encodeURI(
                                                                            history.fileUpload.path.replace("public/", "")
                                                                        )}`;
                                                                        if (filePath.endsWith(".docx")) {
                                                                            return (
                                                                                <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                    <img src={wordIcon} alt='Image.jpg' height="50" width="50" />
                                                                                </a>
                                                                            );
                                                                        }
                                                                        else if (filePath.endsWith(".pdf")) {
                                                                            return (
                                                                                <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                    <img src={pdfIcon} alt='Image.jpg' height="50" width="50" />
                                                                                </a>
                                                                            );
                                                                        }
                                                                        else if (filePath.endsWith(".jpg") || filePath.endsWith(".jpeg") || filePath.endsWith(".png") || filePath.endsWith(".webp") || filePath.endsWith(".avif")) {
                                                                            return (
                                                                                <img
                                                                                    src={fileUrl}
                                                                                    alt="Uploaded File"
                                                                                    style={{ maxWidth: "50px", cursor: "pointer" }}
                                                                                />
                                                                            );
                                                                        }
                                                                        else {
                                                                            return (
                                                                                <span style={{ fontSize: "20px" }}>-</span>
                                                                            );
                                                                        }
                                                                    })()
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </TableCell>
                                                            <TableCell align="right">{history?.comments || "-"}</TableCell>
                                                            <TableCell align="right">
                                                                {history?.updatedAt
                                                                    ? new Date(history.updatedAt).toLocaleString()
                                                                    : "-"}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Box>
                            )}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ p: 2 }}>
                        <Button onClick={handleCloseDialog} variant="contained" color="primary">Close</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={openImage} onClose={() => setOpenImage(false)} maxWidth="md">
                    <Iconify
                        icon="material-symbols:close"
                        onClick={() => setOpenImage(false)}
                        style={{
                            position: 'absolute',
                            top: 10,
                            right: 10,
                            fontSize: 24,
                            cursor: 'pointer',
                            zIndex: 1
                        }}
                    />
                    <DialogContent>
                        <img src={selectedImage} alt="Full View" style={{ width: "100%", height: "auto" }} />
                    </DialogContent>
                </Dialog>



            </Container >
        </>
    );
}

export default ContentCreationSelfAssigned;
